
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Clock } from 'lucide-react';
import { format } from 'date-fns';
import { AdminHistory } from '@/types/admin.types';

interface AdminHistoryTabProps {
  history: AdminHistory[];
}

const AdminHistoryTab = ({ history }: AdminHistoryTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Activity History</CardTitle>
        <CardDescription>
          Record of account actions and changes
        </CardDescription>
      </CardHeader>
      <CardContent>
        {!history || history.length === 0 ? (
          <div className="text-center py-6 text-muted-foreground">
            <Clock className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p>No activity recorded</p>
          </div>
        ) : (
          <div className="space-y-4">
            {history.map((item, index) => (
              <div key={item.id || index} className="relative pl-4 border-l-2 border-muted pb-4">
                <div className="absolute -left-1.5 top-0 h-3 w-3 rounded-full bg-primary" />
                <div className="flex flex-col">
                  <span className="font-medium">{item.action}</span>
                  <span className="text-sm text-muted-foreground">
                    {format(new Date(item.date), 'MMM dd, yyyy • h:mm a')}
                  </span>
                  <p className="mt-1 text-sm">{item.details || "No additional details"}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default AdminHistoryTab;
